import { tap, map, concatMap } from 'rxjs/operators';
import { ApiResponse } from '@core/models/api-response.model';
import { Observable, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Pagination } from '@core/models/pagination.model';
import { DefaultDataService, HttpUrlGenerator } from '@ngrx/data';
import { Injectable } from '@angular/core';
import { MemberReport } from '@core/models/member-report-model';
import { TransactionReport } from '@core/models/transaction-report.model';

@Injectable()
export class TransactionReportDataService extends DefaultDataService<TransactionReport>  {

  messages$ = new Subject<any[]>();
  pagination: Pagination;

  constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator) {
    super('TransactionReport', http, httpUrlGenerator, { root: '' });
  }

  getWithQuery(pageParam: string): Observable<any[]>{
    return this.http.get<ApiResponse>(`/report/transactionreport${pageParam}`).pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    )
  }

  getGameResult(pageParam: string): Observable<any[]>{
    return this.http.get<ApiResponse>(`/report/gameresult${pageParam}`).pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    )
  }

  getRewards(pageParam: string): Observable<any[]>{
    return this.http.get<ApiResponse>(`/report/reward${pageParam}`).pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    )
  }

  getTips(pageParam: string): Observable<any[]>{
    return this.http.get<ApiResponse>(`/report/tip${pageParam}`).pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    )
  }

  getOutstandingBalance(pageParam: string): Observable<any[]>{
    return this.http.get<ApiResponse>(`/report/outstandingbet${pageParam}`).pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    )
  }

  private paginationInit(res: any) {
    if(res) {
      return this.pagination = res.data.paginations;
    }
  }
}
